import {
  defaultTranslations as pbsDefaultTranslations,
  translationsNamespace as pbsTranslationsNamespace,
} from '@ori/personal-beauty-store';

import { defaultTranslations, translationsNamespace } from './defaultTranslations';

/**
 * Combined translations with namespaces that top-area uses. Includes top-area and PBS namespaces
 */
export const defaultTranslationsWithNamespaces = {
  [translationsNamespace]: defaultTranslations,
  [pbsTranslationsNamespace]: pbsDefaultTranslations,
};
